import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { ModuleFE_Dialog } from '../../component-modules/ModuleFE_Dialog.js';
import { LL_H_C, LL_V_L } from '../../components/Layouts/index.js';
import { TS_Icons } from '@nu-art/ts-styles';
import { Component_CollectionGrid } from './Component_CollectionGrid.js';
import { RuntimeModules, exists, resolveContent } from '@nu-art/ts-common';
import './Dialog_IDBCacheComparison.scss';
export class Dialog_IDBCacheComparison extends ComponentSync {
    static defaultProps = {
        modules: () => RuntimeModules().filter(module => exists(module.dbDef?.dbKey)),
    };
    static show = (props) => {
        ModuleFE_Dialog.show({
            content: _jsx(Dialog_IDBCacheComparison, { ...props }),
        });
    };
    render() {
        return _jsxs(LL_V_L, { id: 'dialog__idb-cache-comp', children: [this.render_Header(), this.render_Grid()] });
    }
    render_Header = () => {
        return _jsxs(LL_H_C, { className: 'dialog__idb-cache-comp__header', children: [_jsx("div", { className: 'dialog__idb-cache-comp__header__title', children: 'IDB <-> Cache Comparison' }), _jsx(TS_Icons.x.component, { onClick: () => {
                        ModuleFE_Dialog.close();
                    } })] });
    };
    render_Grid = () => {
        const modules = resolveContent(this.props.modules);
        return _jsx("div", { className: 'dialog__idb-cache-comp__grid-wrapper', children: _jsx(Component_CollectionGrid, { modules: modules }) });
    };
}
//# sourceMappingURL=Dialog_IDBCacheComparison.js.map